export const COMPRAS_VENTAS = 'COMPVENT'
export const GLOBAL = 'GLOBAL'
